import { Button, Center, Group, NumberInput, Stack, Text } from '@mantine/core';
import { useField } from '@mantine/form';
import { modals } from '@mantine/modals';
import { IconSunrise } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';

type RecalculateDatesModalProps = {
  onConfirm: (delay: number) => void;
  initialDelay?: number;
};

export const RecalculateDatesModal = ({
  onConfirm,
  initialDelay = 30,
}: RecalculateDatesModalProps) => {
  const { t } = useTranslation();

  const delay = useField({ initialValue: initialDelay });
  useEffect(() => delay.setValue(initialDelay), [initialDelay]);

  const onClickAdjust = () => {
    modals.closeAll();
    onConfirm(delay.getValue());
  };

  return (
    <Stack>
      <Text>{t(i18nKeys.FORM.PAYMENT_PLAN.STEP_CALCULATION.ADJUST_NEXT_DATES)}</Text>
      <Center>
        <NumberInput
          w="50%"
          {...delay.getInputProps()}
          allowNegative={false}
          allowDecimal={false}
          min={1}
          leftSection={<IconSunrise stroke={1.5} size={20} />}
        />
      </Center>
      <Group justify="end">
        <Button variant="light" color="gray" onClick={modals.closeAll}>
          {t(i18nKeys.PAYMENT_PLAN.WIZARD.STEP4.DO_NOT_ADJUST)}
        </Button>
        <Button onClick={onClickAdjust}>{t(i18nKeys.PAYMENT_PLAN.WIZARD.STEP4.ADJUST)}</Button>
      </Group>
    </Stack>
  );
};
